import { ChartSankeyVariantIcon } from './ChartSankeyVariantIcon';

/**
 * author: Michael Richins
 * id 5FA4943E-5956-4668-ADDD-984914DD745C
 * name chart-sankey-variant
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-sankey-variant.svg
 * tags
 * - Math 
 */
export const ReportSankeyVariantIcon = ChartSankeyVariantIcon;
export default ReportSankeyVariantIcon